import { render } from "./GoTo.vue?vue&type=template&id=059bf872&ts=true"
import script from "./GoTo.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoTo.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/nodes/GoTo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "059bf872"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('059bf872', __exports__)) {
    api.reload('059bf872', __exports__)
  }
  
  module.hot.accept("./GoTo.vue?vue&type=template&id=059bf872&ts=true", () => {
    api.rerender('059bf872', render)
  })

}


export default __exports__